
export default "/assets/exclamation-circle-micro.07e18a0b.svg"